import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RequestService } from './services/request.service';
import { EditorService } from './services/editor.service';
import { ComponentService } from './services/component.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './login/auth-guard.service';
import { CloneService } from './services/clone.service';
import { Title } from '@angular/platform-browser';
import { CanDeactivateGuard } from './services/deactivateGuard.service';
import { LoaderService } from './services/loader.service';
import { loaderInterceptor } from './interceptors/loader.interceptor';
import { authenticationInterceptor } from './interceptors/authentication.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    RequestService,
    EditorService,
    ComponentService,
    AuthService,
    AuthGuard,
    CloneService,
    Title,
    CanDeactivateGuard,
    LoaderService,
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors(
      // Interceptors are chained in the order specified here, so be mindful of adding something!
      [
        authenticationInterceptor,
        errorInterceptor,
        loaderInterceptor,
      ])),
  ]
};
